module.exports = __webpack_public_path__ + "img/wenda_icon.3be13ed0.svg";